var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationMark = function SvgExclamationMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E11B22",
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E11B22",
    d: "M8 9.12a.8.8 0 0 0 .8-.8V4.592a.8.8 0 0 0-1.6 0V8.32a.8.8 0 0 0 .8.8M8 12.208a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  })));
};
export default SvgExclamationMark;